// The FacilityPro marketing site (ellantec-facilitypro-website) uses a fixed
// green identity, distinct from the per-tenant dynamic branding the rest of
// this portal uses. When an org was signed up under one of FacilityPro's
// marketed verticals (Cleaning, Home Services, Security), its auth screens
// here should look like the site the visitor actually signed up on --
// FacilityPro green and logo -- instead of a generic blue default with the
// raw tenant name as the heading.
//
// NOTE: these identifiers match this environment's configured parent orgs
// (SECURITY_PARENT_ORGANIZATION / CLEANING_PARENT_ORGANIZATION /
// HOME_SERVICES_PARENT_ORGANIZATION / SERVICES_PARENT_ORGANIZATION in the
// backend's settings). If those are reconfigured to different identifiers
// in another environment, update this list to match.
export const FACILITYPRO_PARENT_ORG_IDENTIFIERS = [
  'cleaning-parent-org',
  'home-services-parent-org',
  'security-parent',
  'services-parent-org',
]

export const FACILITYPRO_PRIMARY_COLOR = '#176645'
export const FACILITYPRO_LOGO_SRC = '/facilitypro-logo.png'

export function isFacilityProOrigin(organization: { parent_instance_identifier?: string | null } | null | undefined) {
  const parentIdentifier = String(organization?.parent_instance_identifier ?? '').trim().toLowerCase()
  return parentIdentifier.length > 0 && FACILITYPRO_PARENT_ORG_IDENTIFIERS.includes(parentIdentifier)
}
